<div id="infrastructure" class="inner-page">
  <div class="container-fluid px-lg-5 animate-up">
    <h2 class="title">Infrastructure</h2>
    <p class="section-subtitle-orange mt-2">Creating a Strong Foundation for Tomorrow’s Achievers</p>
    
    <p class="inner-lead mt-4">
      Shah Satnam Ji Girls' College is spread across a lush green 8-acre campus, providing a world-class environment for academic and personal growth. Our infrastructure is meticulously designed to offer students modern amenities, specialized learning spaces, and a secure environment that fosters excellence.
    </p>

    <div class="infra-grid">
      <!-- Security -->
      <div class="infra-card">
        <div class="icon-box"><i class="fa fa-shield"></i></div>
        <h5>Security and Main Gate</h5>
        <p>The campus features robust security with vigilant personnel at the main gate and comprehensive 24/7 CCTV surveillance throughout the premises to ensure a safe learning environment.</p>
      </div>

      <!-- Administrative -->
      <div class="infra-card">
        <div class="icon-box"><i class="fa fa-university"></i></div>
        <h5>Administrative Offices</h5>
        <p>A modern hub for institutional management, housing the Principal's Office and executive branches for streamlined day-to-day college operations.</p>
      </div>

      <!-- Computer Labs -->
      <div class="infra-card">
        <div class="icon-box"><i class="fa fa-laptop"></i></div>
        <h5>Computer Laboratories</h5>
        <p>State-of-the-art labs equipped with high-speed internet, advanced coding tools, and modern hardware to support technical education and digital literacy.</p>
      </div>

      <!-- Science Labs -->
      <div class="infra-card">
        <div class="icon-box"><i class="fa fa-flask"></i></div>
        <h5>Physics & Chemistry Labs</h5>
        <p>Specialized scientific laboratories adhering to rigorous safety protocols, equipped with precise instruments for advanced experimental research.</p>
      </div>

      <!-- Media Lab -->
      <div class="infra-card">
        <div class="icon-box"><i class="fa fa-camera"></i></div>
        <h5>Media Production (BAJMC)</h5>
        <p>A specialized journalism and mass communication lab featuring production equipment for news broadcasting, editing, and digital media creation.</p>
      </div>

      <!-- Specialized Labs -->
      <div class="infra-card">
        <div class="icon-box"><i class="fa fa-map-marker"></i></div>
        <h5>Psychology & Geography</h5>
        <p>Dedicated labs for behavioral studies and spatial analysis, featuring experimental psychological tools, GPS equipment, and cartographic resources.</p>
      </div>

      <!-- Student Development -->
      <div class="infra-card">
        <div class="icon-box"><i class="fa fa-users"></i></div>
        <h5>NCC and NSS Hubs</h5>
        <p>Dedicated operational rooms for National Cadet Corps and National Service Scheme activities, promoting leadership and community service.</p>
      </div>

      <!-- CDC -->
      <div class="infra-card">
        <div class="icon-box"><i class="fa fa-lightbulb-o"></i></div>
        <h5>Career Development (CDC)</h5>
        <p>A modern center equipped with smart boards and interactive tools to prepare students for competitive exams and professional career paths.</p>
      </div>

      <!-- Incubation -->
      <div class="infra-card">
        <div class="icon-box"><i class="fa fa-rocket"></i></div>
        <h5>Incubation Centre</h5>
        <p>A dedicated space designed to nurture entrepreneurship, providing resources and mentorship for student-led startups and innovative projects.</p>
      </div>

      <!-- Smart Classrooms -->
      <div class="infra-card">
        <div class="icon-box"><i class="fa fa-desktop"></i></div>
        <h5>Smart Classrooms</h5>
        <p>Digital-ready learning spaces equipped with interactive whiteboards, high-definition projectors, and high-speed internet connectivity.</p>
      </div>

      <!-- Well-being -->
      <div class="infra-card">
        <div class="icon-box"><i class="fa fa-heartbeat"></i></div>
        <h5>First Aid & Yoga Room</h5>
        <p>Facilities dedicated to student well-being, including a fully-equipped medical first aid room and a tranquil space for yoga and meditation.</p>
      </div>

      <!-- Canteen -->
      <div class="infra-card">
        <div class="icon-box"><i class="fa fa-coffee"></i></div>
        <h5>Canteen Facilities</h5>
        <p>A spacious and hygienic canteen offering a variety of nutritious meals and refreshments, serving as a vibrant social hub for students.</p>
      </div>
    </div>

    <div class="mt-section mb-section text-center">
      <hr class="divider">
      <h4 class="section-subtitle">Beyond the Campus</h4>
      <p class="inner-lead">
        Our infrastructure extends to world-class sports facilities at the <strong>Khel Gaon (Sports Village)</strong>, featuring international-level roller skating grounds, cricket pitches, and professional courts for basketball and volleyball.
      </p>
    </div>

  </div>
</div>
